const login = {
    state: {
        userAgreementLogin: "", //  阅读并同意会员协议
    },
    getters: {
        // userAgreementLogin: state => {
        //     return state.userAgreementLogin
        // },
    },
    mutations: {
        // setUserAgreementLogin(state, val) {
        //     state.userAgreementLogin = val;
        // },
    },
    actions: {

    }
}

export default login